import type { V2_V5_TESTS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/v2v5-tests-table/v2v5-tests-table.fr.ts";

import { EInstallTestState } from "~domain/install-tests/models/install-test-state-model.ts";

const testInstallStatus: Record<EInstallTestState, string> = {
  [EInstallTestState.OK]: "Ok",
  [EInstallTestState.NOK]: "Nok",
  [EInstallTestState.UNKNOWN]: "Unknown",
};

export const V2_V5_TESTS_TABLE_ENGLISH_LOCALE = {
  searchPlaceholder: "Search a value...",
  noTestFound: "No test found...",
  headers: {
    testId: "Test Id",
    testDate: "Date",
    target: "Test",
    measuredPower: "Measured power",
    result: "Result",
    resultDetails: "Result details",
    modulatorHwId: "Modulator Hw Id",
    modulatorCsId: "Modulator Cs ID",
    pilotHwId: "Pilot Hw Id",
    testTester: "Tester",
  },
  filters: {
    placeholders: {
      testId: "Search by test id...",
      testDate: "Search by date...",
      target: "Search by test target...",
      measuredPower: "Search by power...",
      result: "Search by results...",
      modulatorHwId: "Search by modulator hw id...",
      modulatorCsId: "Search by modulator cs id...",
      pilotHwId: "Search by hw id...",
      testTester: "Search by tester ...",
    },
  },
  testInstallStatus: testInstallStatus,
} satisfies typeof V2_V5_TESTS_TABLE_FRENCH_LOCALE;
